import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import PropTypes from "prop-types";

import ImportExcelContacts from "../../components/ImportExcelContacts"; // ← resuelve index.jsx
import ContactListTable from "../../components/Table/ContactListTable";

export default function ListarContactos() {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [contacts, setContacts] = useState([]);
  const contactList = useSelector((state) => state.contactList.value);
  const [selectedContacts, setSelectedContacts] = useState([]);

  useEffect(() => {
    setContacts(contactList);
  }, [contactList]);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  const downloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/templates/NuxTemplateContacts.xlsx";
    link.download = "NuxTemplateContacts.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToExcel = () => {
    const cleanedData = contacts.map((c) => ({
      empresa: c.name || "",
      nombre: c.lastname || "",
      telefono: c.num || "",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(cleanedData, {
      header: ["empresa", "nombre", "telefono"],
    });
    ws["!cols"] = [{ wch: 20 }, { wch: 20 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(wb, ws, "Contactos");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "Contactos.xlsx");
  };

  return (
    <>
      {/* Header + Botones */}
      <div className="row mb-5">
        <div className="col">
          <h2 className="page-title">Contacts List</h2>
        </div>
        <div className="col-auto">
          <button type="button" className="btn btn-contact btn-primary mr-2" onClick={exportToExcel}>
            <span className="fe fe-download fe-12 mr-2"></span>Export Contacts
          </button>

          <button type="button" className="btn btn-contact btn-primary mr-2" onClick={showModal}>
            <span className="fe fe-upload fe-12 mr-2"></span>Import Contacts
          </button>

          <button type="button" className="btn btn-contact btn-primary mr-2" onClick={downloadTemplate}>
            <span className="fe fe-download fe-12 mr-2"></span>Template
          </button>

          <button type="button" className="btn btn-contact btn-primary" onClick={() => navigate("/new-contact")}>
            <span className="fe fe-plus fe-12 mr-2"></span>Add New Contact
          </button>
        </div>
      </div>

      {/* Tabla */}
      <div className="card shadow">
        <div className="card-body">
          <ContactListTable contacts={contacts} setClientNumbers={setSelectedContacts} />
        </div>
      </div>

      {/* Modal con el importador */}
      <Modal
        title="Importar Contactos"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        width={720}
      >
        <ImportExcelContacts setIsModalVisible={setIsModalVisible} navigate={navigate} />
      </Modal>
    </>
  );
}

ListarContactos.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object),
  setIsModalVisible: PropTypes.func,
  navigate: PropTypes.func,
};
